import { callFunction } from '@/commands/callFunction'

/**
 * Dépôts de fichiers : actions ouvertes aux participants.
 * Le fichier est envoyé dans le stockage par le client ; le serveur enregistre l'entrée.
 */
export default {
  /** Enregistre un dépôt dans une zone. L'équipe et l'auteur sont déduits du compte. */
  submit({ areaId, name, ext, file }) {
    return callFunction('submitDepot', { areaId, name, ext, file })
  },
  /** Retire un dépôt : le sien pour un participant, n'importe lequel pour un administrateur. */
  withdraw(id) {
    return callFunction('withdrawDepot', { id })
  },
}
